import { render, staticRenderFns } from "./changePsdTab.vue?vue&type=template&id=0035ef82&scoped=true"
import script from "./changePsdTab.vue?vue&type=script&lang=js"
export * from "./changePsdTab.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0035ef82",
  null
  
)

export default component.exports